import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './tooltip';

interface HintProps {
  children: React.ReactNode;
  text: string;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
  delayDuration?: number;
}

export const Hint = ({
  children,
  text,
  side = "top",
  align = "center",
  delayDuration = 700
}: HintProps) => {
  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent side={side} align={align} className="bg-card text-foreground border border-border px-2 py-1 shadow-md">
          <p className="text-xs font-medium">{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};